
export  function devistolink(pdfData){
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(pdfData);
        a.setAttribute("download", `devis${(new Date()).getTime()}.pdf`);
        a.setAttribute('target', '_blank');
        a.click();
        a.remove();
        setTimeout(() => window.URL.revokeObjectURL(a.href), 100) ;
 }

